import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { of } from 'rxjs';
import { finalize, first, switchMap, tap } from 'rxjs/operators';
import { GoogleAnalyticsService } from 'src/app/shared/service/google-analytics.service';
import { Client } from '../../../domain/models';
import { ClientService } from '../../../domain/services/client.service';
import { ChangesNotSavedComponent } from '../../../shared/changes-not-saved';
import { DisclosureFormComponent } from '../../components';
import { Application } from '../../models';
import { applicationPresent } from '../../operators';
import { CurrentApplicationService } from '../../services';
import { ApplicationService } from './../../../application/services';

@Component({
    selector: 'app-disclosure',
    templateUrl: './disclosure.component.html',
    styleUrls: [
        './disclosure.component.scss',
        './../../application-page.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DisclosureComponent
    extends ChangesNotSavedComponent
    implements OnInit
{
    submitted = false; // because we are extending ChangesNotSavedComponent
    submitting = false;

    client: Client | undefined;

    fields$ = this._client.latest.pipe(
        switchMap((client) => this._client.getClientFields(4))
    );

    formValue$ = this._currentApplication.latest.pipe(
        applicationPresent(),
        first(),
        switchMap((application: Application) => {
            if (application?.applicationId) {
                return this.applicationService.getDisclosure(
                    application.applicationId!
                );
            } else return of(null);
        })
    );

    @ViewChild(DisclosureFormComponent) form:
        | DisclosureFormComponent
        | undefined;

    constructor(
        private readonly _fb: UntypedFormBuilder,
        private readonly applicationService: ApplicationService,
        private readonly snackBar: MatSnackBar,
        private readonly router: Router,
        private readonly _transloco: TranslocoService,
        private readonly _currentApplication: CurrentApplicationService,
        private readonly _client: ClientService,
        private readonly _googleAnalyticsService: GoogleAnalyticsService
    ) {
        super();
    }

    ngOnInit() {
        this._googleAnalyticsService.pageView('Application: Disclosure');

        this._client.latest.subscribe((client) => {
            this.client = client;
        });
    }

    onSubmitted(disclosure: any) {
        this.submitting = false;
        this.applicationService
            .saveDisclosure(disclosure)
            .pipe(
                switchMap(() =>
                    this._transloco
                        .selectTranslate('application.snack.saved')
                        .pipe(first())
                ),
                tap((message) => {
                    this.snackBar.open(message, undefined, {
                        duration: 4000
                    });
                    this.postSubmit();
                }),
                finalize(() => (this.submitting = false))
            )
            .subscribe();
    }

    postSubmit() {
        this.submitted = true;
        this._currentApplication.reset();
        this.router.navigateByUrl(
            `${runtimeConfig.clientCode}/application-confirmed`
        );
    }

    isChanged(): boolean {
        return this.form?.touched ?? false;
    }

    isSaved(): boolean {
        return this.submitted;
    }
}
